import React__default from 'react';
import { DismissableBanner, EmptyState, LogViewer } from '@backstage/core-components';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import { usePodLogs } from './usePodLogs.esm.js';

const PodLogs = ({
  containerScope,
  previous
}) => {
  const { value, error, loading } = usePodLogs({
    containerScope,
    previous
  });
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, error && /* @__PURE__ */ React__default.createElement(
    DismissableBanner,
    {
      ...{
        message: error.message,
        variant: "error",
        fixed: false
      },
      id: "pod-logs"
    }
  ), /* @__PURE__ */ React__default.createElement(
    Paper,
    {
      elevation: 1,
      style: { height: "100%", width: "100%", minHeight: "55rem" }
    },
    loading && /* @__PURE__ */ React__default.createElement(Skeleton, { variant: "rect", width: "100%", height: "100%" }),
    !loading && value !== void 0 && (value.text === "" ? /* @__PURE__ */ React__default.createElement(
      EmptyState,
      {
        missing: "data",
        title: "No logs emitted",
        description: "No logs were emitted by the container"
      }
    ) : /* @__PURE__ */ React__default.createElement(LogViewer, { text: value.text }))
  ));
};

export { PodLogs };
//# sourceMappingURL=PodLogs.esm.js.map
